import { getListShowCase } from '@/services/workflow';
import { isEmpty } from 'lodash';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { KEY_SORT, ShowCase } from './constants';

const useFetchToolAI = () => {
  const pageSize = 20;
  const dataRef = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [listShowcase, setListShowcase] = useState<ShowCase[]>([]);
  const searchParam = useSearchParams();
  const search = searchParam.get('search');
  const categoryId = searchParam.get('categoryId');
  const totalLike = searchParam.get(KEY_SORT.LIKE) ?? undefined;
  const totalRun = searchParam.get(KEY_SORT.RUN) ?? undefined;
  const getCreatedAtDefault = () => {
    if (totalRun || totalLike) return undefined;
    return 'DESC';
  };
  const createdAt = searchParam.get(KEY_SORT.CREATED) ?? getCreatedAtDefault();

  const getSortParams = () => {
    return JSON.stringify({
      createdAt,
      totalUsedTimes: totalRun,
      totalReactions: totalLike,
    });
  };

  const getFilterParams = () => {
    let filter = {};
    if (search) filter = { ...filter, name: search };
    if (categoryId) filter = { ...filter, categoryId: Number(categoryId) };

    return isEmpty(filter) ? undefined : JSON.stringify(filter);
  };

  const handleGetListShowCase = async (page: number) => {
    setIsLoading(true);
    try {
      const res = await getListShowCase({
        size: pageSize,
        offset: (page - 1) * pageSize,
        sort: getSortParams(),
        filter: getFilterParams(),
      });

      if (page === 1) {
        dataRef.current = [];
        setListShowcase([]);
      }
      dataRef.current = dataRef.current.concat(res?.items || []);
      setListShowcase(dataRef.current);
    } catch (error) {
      setListShowcase(dataRef.current);
    }
    setIsLoading(false);
  };

  const loadMore = (page: number) => {
    setCurrentPage(page);
    handleGetListShowCase(page);
  };

  useEffect(() => {
    setCurrentPage(1);
    handleGetListShowCase(1);
  }, [search, createdAt, totalLike, totalRun, categoryId]);

  return {
    isLoading,
    currentPage,
    setCurrentPage,
    listShowcase,
    loadMore,
  };
};

export default useFetchToolAI;
